module.exports = __webpack_public_path__ + "img/hero-blur.09463cc7.png";